export default "__VITE_ASSET__D7Vus6T1__"